import React from 'react';

import { useLeaderBoardId } from './hooks';

export const withLeaderBoardId = Wrapped => (props) => {
    const leaderboardId = useLeaderBoardId();

    return (
        <Wrapped
            {...props}
            leaderboardId={leaderboardId}
        />
    );
};
